import { setDomContext, setWindowContext, getGroupSoftwareHash } from '@/helpers/context';
import { debounce } from '@/helpers/utilities';
import trackingActionMapper from '@/helpers/trackingActionMapper';
import { loadLanguageAsync } from '@/plugins/i18n';

export default {
  // function to set the components context in order below
  // - DOM
  // - WINDOW
  // debounce used so it does not trigger to many times as components load
  setContext: debounce(({ commit, state, getters }) => {
    const { context } = state;
    const domContext = setDomContext(context);
    const windowContext = setWindowContext(context);
    const groupSoftwareHash = getGroupSoftwareHash();

    commit('setValue', {
      key: 'context',
      value: { ...context, ...domContext, ...windowContext, groupSoftwareHash },
    });

    const { language, country } = getters;
    loadLanguageAsync(language, country);
  }, 100, { leading: true, trailing: false }),

  TRACKING_EVENT({ state, dispatch, rootState }, { event, data }) {
    const { module } = state.context.trackingService;
    if (module && rootState.ndc[module] && trackingActionMapper[module][event]) {
      const actionName = `ndc/${module}/${trackingActionMapper[module][event]}`;
      dispatch(actionName, data, { root: true });
    }
  },
};
